import { render, staticRenderFns } from "./Rule-Template-Selector.vue?vue&type=template&id=63f99258&lang=pug"
import script from "./Rule-Template-Selector.vue?vue&type=script&lang=ts"
export * from "./Rule-Template-Selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports